if (!customElements.get("before-after-image-slider")) {
  customElements.define(
    "before-after-image-slider",
    class BeforeAfterImageSlider extends HTMLElement {
      connectedCallback() {
        this.mediaWrapper = this.querySelector("[data-media-wrapper]");
        this.inputSlider = this.querySelector("[data-input-slider]");
        this.handle = this.querySelector(".before-after__handle");

        if (!this.mediaWrapper || !this.inputSlider) return;

        this._syncValue = this.syncValue.bind(this);
        this.inputSlider.addEventListener("input", this._syncValue);
        this.inputSlider.addEventListener("pointerdown", this._syncValue);

        // Press feedback of the shared drag-cursor component. Release is bound
        // on window so a pointer-up outside the media still resets the state.
        this._onPressStart = this.onPressStart.bind(this);
        this._onPressEnd = this.onPressEnd.bind(this);
        this.inputSlider.addEventListener("pointerdown", this._onPressStart);
        window.addEventListener("pointerup", this._onPressEnd);
        window.addEventListener("pointercancel", this._onPressEnd);

        this.syncValue();
      }

      disconnectedCallback() {
        if (this.inputSlider) {
          this.inputSlider.removeEventListener("input", this._syncValue);
          this.inputSlider.removeEventListener("pointerdown", this._syncValue);
          this.inputSlider.removeEventListener(
            "pointerdown",
            this._onPressStart
          );
        }
        if (this._onPressEnd) {
          window.removeEventListener("pointerup", this._onPressEnd);
          window.removeEventListener("pointercancel", this._onPressEnd);
        }
      }

      onPressStart() {
        this.handle?.classList.add("is-dragging");
      }

      onPressEnd() {
        this.handle?.classList.remove("is-dragging");
      }

      syncValue() {
        const value =
          (Number(this.inputSlider.value) - Number(this.inputSlider.min)) /
          (Number(this.inputSlider.max) - Number(this.inputSlider.min));
        const compareValue = Math.round(value * 100);

        this.mediaWrapper.style.setProperty(
          "--before-after-value",
          String(compareValue)
        );
      }
    }
  );
}
